/**
分页组件
*/
<template>
  <div class="hz-pager">
    <div class="hz-pager-left">
      总条数：{{pageCount}}
      &nbsp&nbsp
      总页数：{{Math.ceil(pageCount/pageSize)}}
    </div>
    <div class="hz-pager-right">
      <button class="hz-button">首页</button>
      <button class="hz-button" >上一页</button>
      <button @click="nextPageEvent()" id="nextPage">下一页</button>
      <button class="hz-button">尾页</button>
      <input type="text" class="hz-text" style="width:60px;margin-left:10px;" v-model="currentPage"/>
      <button class="hz-button">GO</button>
    </div>
  </div>
</template>
<script>
  export default {
    props:
      {
        data: { type: Object},// 分页信息（包含总数据量、总页数、当前第几页、每个条数）
        pageNo:{type:Number,default:1},
        pageSize:{type:Number,default:5},
        currentPage:{type:Number,default:1},
      },
    data(){
      return{
        dataObject:{},
        pageCount:0
      }
    },
    watch:{
      data(data){
        this.pageCount = data.pageDataCount;
      }
    },
    methods:{
      // OK按钮事件
      nextPageEvent:function(){
        this.$nextTick(()=>{
        });
        this.$emit("pageEvent",function () {});
        this.pageNo++;
        this.$emit('update:pageNo',this.pageNo);
        this.$emit('update:pageSize',this.pageSize);
        this.$emit('update:currentPage',this.currentPage);
      },
    },
  }

</script>
<style>
  .hz-pager{
    text-align: center;
  }
  .hz-pager-left{
    display: inline-block;
  }
  .hz-pager-right{
    margin-left: 100px;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages.vue